var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHideEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6.62l2.33-2.32-1.42-1.41L17 5.6a11.69 11.69 0 0 0-5-1.1A11.83 11.83 0 0 0 1 12a11.84 11.84 0 0 0 4.2 5.34l-2.32 2.33 1.42 1.41 2.7-2.7a11.63 11.63 0 0 0 5 1.12A11.83 11.83 0 0 0 23 12a11.92 11.92 0 0 0-4.25-5.38zM3.18 12a9.77 9.77 0 0 1 12.24-4.87l-1.06 1.06A4.44 4.44 0 0 0 12 7.5 4.51 4.51 0 0 0 7.5 12a4.44 4.44 0 0 0 .69 2.36l-1.55 1.55A9.79 9.79 0 0 1 3.18 12zm11.32 0a2.5 2.5 0 0 1-2.5 2.5 2.47 2.47 0 0 1-.94-.19l3.25-3.25a2.47 2.47 0 0 1 .19.94zm-5 0A2.5 2.5 0 0 1 12 9.5a2.34 2.34 0 0 1 .88.17l-3.21 3.21A2.34 2.34 0 0 1 9.5 12zm2.5 5.5a9.81 9.81 0 0 1-3.47-.65l1.06-1.06a4.49 4.49 0 0 0 6.2-6.2l1.53-1.53a9.84 9.84 0 0 1 3.5 3.94A9.76 9.76 0 0 1 12 17.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideEye);
export default __webpack_public_path__ + "static/media/hide-eye.921327dbdf372073d8347735475cb138.svg";
export { ForwardRef as ReactComponent };